import { admissionYear } from "./query";
import { useQuery } from "@tanstack/react-query";
import { PostModel } from "common/models/BaseModel";
import { IAdmissionYearGridFilter } from "./types";

export function GetAdmissionYears(
  model: PostModel<IAdmissionYearGridFilter> | undefined
) {
  return useQuery(admissionYear.list(model));
}

export function GetAdmissionYear(Id?: string | null) {
  return useQuery({
    ...admissionYear.getById(Id),
    enabled: Boolean(Id),
  });
}

export function GetAdmissionYearValues() {
  return useQuery({
    ...admissionYear.getAdmissionYearValues(),
    refetchOnMount: true,
  });
}

export function GetAdmissionYearView(id: string | null | undefined, isOpen: boolean) {
  return useQuery({
    ...admissionYear.getViewById(id),
    enabled: Boolean(id) && isOpen,
  });
}
